export type TypeCentroCustoTipo = {
    codigo?: number,
    tipo?: string,
    ativo?: boolean
}

export enum EnumCentroCustoTipo {
    GRUPO = 1,
    ITEM = 2
}